<div class="pricing-block">
  <div class="subscriptions-title">Ready to get started?</div>
  <div class="subscriptions-description text-block">Find the best plan according to your needs with no transaction fees and hidden costs</div>
  <pricing-component class="subscriptions-list"></pricing-component>
</div>

